import React, {useState, useEffect} from 'react';
import AddressField from "./AddressField";
import YandexMap from "../../Fields/Map/YandexMap";
import {isEmpty, path, prop} from "ramda";
import Modal from "../../Modal/Modal";
import styled from "styled-components";
import {Form as FinalForm} from 'react-final-form'
import Fields from "../../Fields/Fields";
import useCreate from "../../../hooks/useCreate";
import {getSerializedData} from "../../../helpers/get";
import * as STATES from "../../../redux/reducers/states";
import {addressCreateAction, addressDeleteAction, addressEditAction} from "../../../actions/adress";
import {useTranslate} from "../../../helpers/translate";


const Container = styled.div`
    max-height: ${({step}) => (step === 1 ? '360px' : '600px')};
    min-height: 300px;
    overflow: auto;
    padding: 15px 8px;

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    scrollbar-gutter: stable both-edges;
`
const addressFields = [
  'location',
  'name',
  'building',
  'entrance',
  'floor',
  'room',
  'comment',
]
const FieldsAdres = ({fields, step, setStep, loading, isDetail, editAddress, values}) => {
  const addressInputs = prop('address', fields)
  const locationInputs = prop('location', fields)
  const onAddressChange = addressInputs.input.onChange
  const addressValue = addressInputs.input.value

  return (
    <Container step={step} isDetail={isDetail}>
      {step === 1 ? (
        <AddressField
          name={'address'}
          loading={loading}
          input={addressInputs.input}
          locationInputs={locationInputs.input}
          onIconClick={() => setStep(0)}
          isDetail={isDetail}
          editAddress={editAddress}
          values={values}
        />
      ) : <YandexMap
        {...locationInputs}
        initialLocation={path(['location'], values)}
        onToggle={() => setStep(1)}
        addressValue={addressValue}
        onAddressChange={onAddressChange}
      />}
    </Container>
  )
}

const FieldsContent = ({step, setStep, isDetail, deleteAddress, createAddress, editAddress, values, form, handleSubmit}) => {
  useEffect(() => {
    const unsubscribe = form.subscribe(
      ({ values }) => {
        if (values?.address) {
          form.change('name', values.address);
        }
      },
      { values: true }
    );

    return () => unsubscribe();
  }, [form]);

  return (
    <form onSubmit={handleSubmit} style={{height: '100%'}}>
      <Fields
        names={[
          'location',
          'address',
        ]}
      >
        {(fields) => {
          return (
            <FieldsAdres
              fields={fields}
              step={step}
              setStep={setStep}
              loading={isDetail ? deleteAddress.loading : createAddress.loading}
              isDetail={isDetail}
              editAddress={editAddress}
              values={values}
            />
          )
        }}
      </Fields>
    </form>
  )
}

const AddAddressModal = ({open, onClose, onSuccess, detail}) => {
  const {t} = useTranslate()
  const [step, setStep] = useState(0)

  const createAddress = useCreate({
    action: addressCreateAction,
    onSuccess: () => {
      setStep(0)
      onClose()
      onSuccess()
    },
    serializer: (values) => ({...getSerializedData(addressFields, values)}),
    stateName: STATES.CREATE_ADDRESS,
    childIsNull: true
  })

  const editAddress = useCreate({
    action: addressEditAction,
    onSuccess: () => {
      setStep(0)
      onClose()
      onSuccess()
    },
    serializer: (values) => ({...getSerializedData(addressFields, values), id: path(['data', 'id'], detail)}),
    stateName: STATES.CREATE_ADDRESS,
    childIsNull: true
  })

  const deleteAddress = useCreate({
    action: addressDeleteAction,
    onSuccess: () => {
      onClose()
      onSuccess()
    },
    serializer: () => ({user_address: path(['data', 'id'], detail)}),
    stateName: STATES.CREATE_ADDRESS,
    childIsNull: true
  })

  const isDetail = detail && !isEmpty(detail)

  useEffect(() => {
    if (isDetail) {
      setStep(1)
    } else {
      setStep(0)
    }
  }, [detail]);

  const detailData = prop('data', detail)
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={isDetail ? t('detail') : t('add_address')}
        showHeader={true}
        bodyPadding={'0px'}
      >
        <FinalForm
          onSubmit={isDetail ? deleteAddress.onSubmit : createAddress.onSubmit}
          initialValues={{
            name: prop('name', detailData),
            entrance: prop('entrance', detailData),
            floor: prop('floor', detailData),
            room: prop('room', detailData),
            comment: prop('comment', detailData),
            location: prop('location', detailData),
          }}
          render={({handleSubmit, values, form, ...formProps}) => {
            return (
              <FieldsContent
                step={step}
                setStep={setStep}
                createAddress={createAddress}
                deleteAddress={deleteAddress}
                editAddress={editAddress}
                values={values}
                form={form}
                handleSubmit={handleSubmit}
                isDetail={isDetail}
              />
            )
          }}
        />
      </Modal>
    </>
  );
};

export default AddAddressModal;
